import React from 'react';
import TituloMuroCarbonDeBambu from '../components/sections/MuroCarbonDeBambu/TituloMuroCarbonDeBambu'; 
import IntroMuroCarbonDeBambu from '../components/sections/MuroCarbonDeBambu/IntroMuroCarbonDeBambu'; 
import InfoMuroCarbonDeBambu from '../components/sections/MuroCarbonDeBambu/InfoMuroCarbonDeBambu';  
// import CatalogoMuroCarbonDeBambu from '../components/sections/MuroCarbonDeBambu/CatalogoMuroCarbonDeBambu'; 
import FormularioContactoCarbonBambu from '../components/sections/MuroCarbonDeBambu/FormularioContactoCarbonBambu'; 
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

const MuroCarbonDeBambu = () => {
  return (
    <div>
      <Header />
        <TituloMuroCarbonDeBambu />   
        <IntroMuroCarbonDeBambu />  
        <InfoMuroCarbonDeBambu />  
        {/* <CatalogoMuroCarbonDeBambu />    */}
        <FormularioContactoCarbonBambu /> 
      <Footer />
    </div>
  );
};

export default MuroCarbonDeBambu;
